module.exports = __webpack_public_path__ + "static/board-22-34e003479f2b851c0174c338ac841ac3.jpg";